export const it = {
  documents: {
    startDialog: {
      start: 'Inizia ora',
      resume: 'Riprendi la lettura',
      restart: 'Rileggi il documento',
      duration: 'Tempo di lettura: {{time}} minuti',
      credits: '{{credits}} Crediti',
      colleaguesHint: {
        singular: 'Un altro tuo collega ha già letto il documento, non restare indietro!',
        plural: 'Oltre {{colleagues}} colleghi hanno già letto il documento, non restare indietro!',
      },
      errors: {
        noCredits: 'Non hai crediti sufficienti per iniziare il documento.',
      },
    },
    player: {
      genericDocumentError:
        'Si è verificato un problema durante il caricamento del documento. Per favore, riprova.',
      finishReading: 'Ho finito di leggere',
    },
    confirmExitFromDocumentDialog: {
      title: 'Esci dal contenuto',
      description:
        'Uscendo dal documento, avrai la possibilità di completarlo in un secondo momento, senza perdere i tuoi progressi.',
      adminDescription:
        'Se chiudi il documento adesso, non potrai riprendere dal punto in cui hai interrotto, ma potrai rileggerlo tutte le volte che vuoi dall’inizio',
      confirm: 'Esci',
      cancel: 'Annulla',
    },
    feedbackDocumentDialog: {
      title: 'Come valuti questo documento?',
      submittedTitle: 'Grazie per il tuo feedback!',
      description: 'La valutazione è facoltativa.',
      commentPlaceholder: 'Lascia un commento per farci sapere la tua esperienza',
      submittedDescription:
        'Prosegui con il training per non perderti i prossimi contenuti disponibili!',
      confirm: 'Invia',
      backToTraining: 'Torna al training',
    },
  },
};
